(function () {
    'use strict';

    var app = angular.module('inoApp');

    app.directive('authNotAuthenticatedDialog', ['$rootScope', 'config', function ($rootScope, config) {
        var directive = {
            restrict: 'A',
            templateUrl: 'templates/core/layout/authNotAuthenticatedDialog.html',
            link: link
        };
        return directive;

        function link(scope) {
            var showDialog = function () {
                scope.toggleAuthenticationDialog(true);
            };

            scope.toggleAuthenticationDialog(false);
            $rootScope.$on(config.events.auth.notAuthenticated, showDialog);
        }
    }]);
})();